export default function EmptyState({ icon: Icon, title, description, action }) {
    return (
        <div className="zentra-card-static p-10 flex flex-col items-center justify-center text-center gap-3" data-testid="empty-state">
            {Icon && (
                <div className="w-12 h-12 rounded-full bg-zentra-bg flex items-center justify-center text-zentra-olive">
                    <Icon size={22} strokeWidth={1.5} />
                </div>
            )}
            <h3 className="font-display text-lg font-semibold text-zentra-ink">{title}</h3>
            {description && <p className="text-sm text-zentra-muted max-w-md">{description}</p>}
            {action}
        </div>
    );
}
